const CHANNEL_NAME = 'external_channel'
const CHECK_INTERVAL_MS = 5 * 60 * 1000
const STARTUP_DELAY_MS = 10 * 1000
const RELOAD_GUARD_KEY = 'external_version_reload_guard'
const CROSS_TAB_SIGNAL_KEY = 'external_version_signal'

let broadcastChannel = null
let checking = false

function runningVersion() {
  return process.env.VERSION
}

function claimReload(newVersion) {
  try {
    if (sessionStorage.getItem(RELOAD_GUARD_KEY) === newVersion) return false
    sessionStorage.setItem(RELOAD_GUARD_KEY, newVersion)
    return true
  } catch (e) {
    console.warn('Version check: sessionStorage unavailable, allowing the reload', e)
    return true
  }
}

function forceReload() {
  window.location.reload()
}

function notifyOtherTabs(newVersion) {
  const payload = { type: 'VERSION_CHANGED', from: runningVersion(), to: newVersion }
  if (broadcastChannel) {
    broadcastChannel.postMessage(payload)
  } else {
    try {
      localStorage.setItem(CROSS_TAB_SIGNAL_KEY, JSON.stringify({ ...payload, ts: Date.now() }))
    } catch (e) { /* storage unavailable */ }
  }
}

function onCrossTabMessage(payload) {
  if (!payload || payload.type !== 'VERSION_CHANGED') return
  if (payload.to === runningVersion()) return
  if (claimReload(payload.to)) {
    forceReload()
  }
}

async function checkVersion() {
  if (checking) return
  checking = true
  try {
    const res = await fetch('/api/LocalVersion', { cache: 'no-store' })
    if (!res.ok) return
    const data = await res.json()
    const serverVersion = data && data.version
    if (serverVersion && serverVersion !== runningVersion()) {
      notifyOtherTabs(serverVersion)
      if (claimReload(serverVersion)) {
        forceReload()
      }
    }
  } catch (e) {
    // offline / edge / unreachable: skip silently, next tick retries
  } finally {
    checking = false
  }
}

export function startVersionCheck() {
  if (typeof BroadcastChannel !== 'undefined') {
    broadcastChannel = new BroadcastChannel(CHANNEL_NAME)
    broadcastChannel.onmessage = (event) => onCrossTabMessage(event.data)
  } else {
    window.addEventListener('storage', (event) => {
      if (event.key !== CROSS_TAB_SIGNAL_KEY || !event.newValue) return
      try {
        onCrossTabMessage(JSON.parse(event.newValue))
      } catch (e) { /* ignore malformed payloads */ }
    })
  }

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void checkVersion()
  })
  setInterval(checkVersion, CHECK_INTERVAL_MS)
  setTimeout(checkVersion, STARTUP_DELAY_MS)
}

export default startVersionCheck
